import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ActivityService } from "./activity.service";

const initialState = {
  activities: [],
  pagination: null,
  types: [],
  success: false,
  isLoading: false,
  error: null,
};

// Get activities with filtering
export const getActivities = createAsyncThunk(
  "activity/getActivities",
  async (params = {}, { rejectWithValue }) => {
    try {
      const _activityService = new ActivityService();
      const response = await _activityService.getActivities(params);
      return response;
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Failed to fetch activities";
      return rejectWithValue(message);
    }
  }
);

// Get activity types
export const getActivityTypes = createAsyncThunk(
  "activity/getActivityTypes",
  async (_, { rejectWithValue }) => {
    try {
      const _activityService = new ActivityService();
      const response = await _activityService.getActivityTypes();
      return response.types;
    } catch (error) {
      const message = error.response?.data?.message || error.message || "Failed to fetch activity types";
      return rejectWithValue(message);
    }
  }
);

export const activitySlice = createSlice({
  name: "activity",
  initialState,
  reducers: {
    clearActivities: (state) => {
      state.activities = [];
      state.pagination = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get activities
      .addCase(getActivities.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getActivities.fulfilled, (state, action) => {
        state.isLoading = false;
        state.activities = action.payload.data;
        state.pagination = action.payload.pagination;
        state.success = true;
      })
      .addCase(getActivities.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        state.success = false;
      })
      // Get activity types
      .addCase(getActivityTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getActivityTypes.fulfilled, (state, action) => {
        state.isLoading = false;
        state.types = action.payload;
      })
      .addCase(getActivityTypes.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default activitySlice.reducer;

export const { clearActivities } = activitySlice.actions;
